import { render, staticRenderFns } from "./expand_button.vue.js?vue&type=template&id=2f921d88&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./expand_button.vue?vue&type=template&id=2f921d88&vue3"
import script from "./expand_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./expand_button.vue?vue&type=script&lang=js&vue3"
export * from "./expand_button.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./expand_button.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports